import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getHomeBanner = createAsyncThunk(
  "home/banner",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_HOME_BANNERS);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllBanner = createAsyncThunk(
  "home/all-banner",
  async ({ banner_type_id = "" }, { rejectWithValue }) => {
    try {
      const bannerData = await GET(`${API.GET_ALL_BANNERS}/${banner_type_id}`);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOfferBanner = createAsyncThunk(
  "home/offer-banner",
  async ({ banner_type_id = "" }, { rejectWithValue }) => {
    try {
      const bannerData = await GET(`${API.GET_ALL_BANNERS}/${banner_type_id}`);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getCheckupBanner = createAsyncThunk(
  "home/checkup-banner",
  async ({ banner_type_id = "" }, { rejectWithValue }) => {
    try {
      const bannerData = await GET(`${API.GET_ALL_BANNERS}/${banner_type_id}`);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting Add banners
export const getAddBanner = createAsyncThunk(
  "home/add-banner",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_ADVERTISMENT_BANNERS);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting Add banners
export const getCoupons = createAsyncThunk(
  "home/add-coupons",
  async (_, { rejectWithValue }) => {
    try {
      const couponData = await GET(`${API.COUPON}?per_page=${5}`);
      return couponData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting Add banners
export const getWhy_Choose_Us = createAsyncThunk(
  "home/add-whychooseus",
  async (_, { rejectWithValue }) => {
    try {
      const whyprintoutData = await GET(API.GET_Why_Choose_Us);
      return whyprintoutData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting Add banners
export const getNeeds = createAsyncThunk(
  "home/add-needs",
  async (_, { rejectWithValue }) => {
    try {
      const needsData = await GET(API.GET_Needs);
      return needsData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting Add banners
export const getPartners = createAsyncThunk(
  "home/add-partners",
  async (_, { rejectWithValue }) => {
    try {
      const partnersData = await GET(API.GET_Partners);
      return partnersData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOfferProduct = createAsyncThunk(
  "home/offer-product",
  async (_, { rejectWithValue }) => {
    try {
      const partnersData = await GET(API.GET_OFFER_PRODUCT);
      return partnersData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for posting Form
export const postSubscriber = createAsyncThunk(
  "home/all-Subscriber",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.POST_Subscriber}`, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getHeaderNews = createAsyncThunk(
  "home/header-news",
  async (_, { rejectWithValue }) => {
    try {
      const partnersData = await GET(API.GET_HEADER_NEWS);
      return partnersData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTrendingProduct = createAsyncThunk(
  "home/trending-product",
  async (_, { rejectWithValue }) => {
    try {
      const partnersData = await GET(API.GET_TRENDING_PRODUCT);
      return partnersData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const homeSlice = createSlice({
  name: "home",
  initialState: {
    name: "",
    image: "",
    banners: [],
    header_news: [],
    trending_product: [],
    allbanners: {},
    offerbanners: {},
    checkupbanners: {},
    addBanners: [],
    addCoupons: [],
    addWhyChooseUs: [],
    addNeeds: [],
    addPartners: [],
    all_offer_product: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHomeBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHomeBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.banners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getHomeBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getHeaderNews.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHeaderNews.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.header_news = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getHeaderNews.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

       .addCase(getTrendingProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTrendingProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.trending_product = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getTrendingProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allbanners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getOfferBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOfferBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.offerbanners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getOfferBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getCheckupBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCheckupBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.checkupbanners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getCheckupBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAddBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAddBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addBanners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAddBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getCoupons.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCoupons.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addCoupons = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getCoupons.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getWhy_Choose_Us.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getWhy_Choose_Us.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addWhyChooseUs = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getWhy_Choose_Us.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getNeeds.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getNeeds.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addNeeds = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getNeeds.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getPartners.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPartners.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addPartners = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getPartners.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getOfferProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOfferProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_offer_product = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getOfferProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(postSubscriber.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(postSubscriber.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.formData = action.payload;
      })
      .addCase(postSubscriber.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default homeSlice.reducer;
